import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';

import Actions from '../action';
import { appConstant, apiUrl } from '@constants';
import { getAuthToken } from '@helpers';

const authToken = getAuthToken();
const config = { headers: { Authorization: authToken } };

export function* crmWorker(action) {
	try {
		const uri = `${appConstant.domain}${apiUrl.GET_USER}${action.authKey}`;
		const res = yield call(Axios.get, uri, config);
		if (res.data.success && res.data.messages) {
			const { email, accessLevel } = res.data.messages;
			yield put(Actions.creators.authorizeSuccess({ email, accessLevel }));
		} else {
			message.error(res.data && res.data.messages && res.data.messages[0]);
		}
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.authorizeFailed());
	}
}

export function* approveWorker(action) {
	try {
		const uri = `${appConstant.domain}${apiUrl.ACTIVATE_USER}${action.authKey}`;
		yield call(Axios.put, uri, config);

		yield put(Actions.creators.approveSuccess());
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.approveFailed());
	}
}

export function* rejectWorker(action) {
	try {
		const uri = `${appConstant.domain}${apiUrl.DEACTIVATE_USER}${action.authKey}`;
		yield call(Axios.put, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.rejectSuccess());
	} catch (err) {
		let mes = err.toString(err) === 'Error: Request failed with status code 400' ? appConstant.userNotExist : 'Something went wrong';
		message.error(mes);
		yield put(Actions.creators.rejectFailed());
	}
}

export default function* crmWatcher() {
	yield takeEvery(Actions.types.AUTHORIZE_CRM, crmWorker);
	yield takeEvery(Actions.types.APPROVE_STARTED, approveWorker);
	yield takeEvery(Actions.types.REJECT_STARTED, rejectWorker);
}
